import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { fileUrl } from "@/lib/api";

export function PageCard({ page, onDelete }) {
  const isEvent = page.type === "event";
  const title = isEvent ? page.event_name || "Untitled Event" : page.title || "Untitled Release";

  return (
    <div
      className="group rounded-2xl border border-white/10 bg-[#121824] hover:bg-[#161f30] transition-colors overflow-hidden"
      data-testid={`page-card-${page.id}`}
    >
      <Link to={`/builder/${page.id}`} className="block">
        <div className="aspect-[16/10] bg-[#1A2232] relative overflow-hidden">
          {page.cover_image_url ? (
            <img src={fileUrl(page.cover_image_url)} alt={title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <i className={isEvent ? "fa-solid fa-calendar-days text-3xl text-white/20" : "fa-solid fa-record-vinyl text-3xl text-white/20"} />
            </div>
          )}
          <Badge className={`absolute top-3 left-3 border-0 ${page.status === "published" ? "bg-emerald-500/90 text-black" : "bg-white/15 text-white"}`} data-testid={`page-card-status-${page.id}`}>
            {page.status === "published" ? "Published" : "Draft"}
          </Badge>
          <Badge variant="outline" className="absolute top-3 right-3 border-white/20 bg-black/40 text-white capitalize">
            {page.type === "music" ? "Release" : "Event"}
          </Badge>
        </div>
      </Link>
      <div className="p-4 space-y-3">
        <Link to={`/builder/${page.id}`}>
          <h3 className="font-bold font-display truncate" data-testid={`page-card-title-${page.id}`}>{title}</h3>
          <p className="text-xs text-slate-400 font-mono-slug truncate">{page.url_handle ? `/${page.url_handle}/${page.slug}` : `/s/${page.slug}`}</p>
        </Link>
        <div className="flex items-center justify-between text-xs text-slate-400">
          <span data-testid={`page-card-views-${page.id}`}><i className="fa-solid fa-eye mr-1 opacity-60" />{page.views_count || 0} views</span>
          <span data-testid={`page-card-clicks-${page.id}`}><i className="fa-solid fa-hand-pointer mr-1 opacity-60" />{page.clicks_count || 0} clicks</span>
        </div>
        <div className="flex items-center gap-2 pt-1">
          <Link to={`/builder/${page.id}`} className="flex-1" data-testid={`page-card-edit-${page.id}`}>
            <button className="w-full text-xs font-semibold rounded-full py-1.5 bg-white/10 hover:bg-white/15 transition-colors">Edit</button>
          </Link>
          <Link to={`/pages/${page.id}/analytics`} className="flex-1" data-testid={`page-card-analytics-${page.id}`}>
            <button className="w-full text-xs font-semibold rounded-full py-1.5 bg-white/10 hover:bg-white/15 transition-colors">Analytics</button>
          </Link>
          <button
            onClick={() => onDelete(page.id)}
            className="rounded-full p-2 bg-white/5 hover:bg-rose-500/20 hover:text-rose-400 transition-colors"
            data-testid={`page-card-delete-${page.id}`}
          >
            <i className="fa-solid fa-trash text-xs" />
          </button>
        </div>
      </div>
    </div>
  );
}
